/**
 * @file job.actions.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Jan 31, 2026 14:27
 */

// -------------------------------------------------------------------
// jobSearch.initialQuery - requests all jobs for a userId 
//                          (not paginated; limited to 20 jobs)
// -------------------------------------------------------------------
export const JOB_SEARCH_INITIAL_QUERY_REQUEST = 'JOB_SEARCH_INITIAL_QUERY_REQUEST';
export function jobSearchInitialQueryRequest() {

    return {
        type: JOB_SEARCH_INITIAL_QUERY_REQUEST,
        payload: {
        }
    };
}

export const JOB_SEARCH_INITIAL_QUERY_SUCCESS = 'JOB_SEARCH_INITIAL_QUERY_SUCCESS';
export function jobSearchInitialQuerySuccess(payload) {
    return {
        type: JOB_SEARCH_INITIAL_QUERY_SUCCESS,
        payload,
    };
}

export const JOB_SEARCH_INITIAL_QUERY_FAILURE = 'JOB_SEARCH_INITIAL_QUERY_FAILURE';
export function jobSearchInitialQueryFailure(error) {
    return {
        type: JOB_SEARCH_INITIAL_QUERY_FAILURE,
        payload: JSON.stringify(error),
    };
}

// -------------------------------------------------------------------
// jobSearch.jobSearchDelete
// -------------------------------------------------------------------
export const JOB_SEARCH_DELETE_REQUEST = 'JOB_SEARCH_DELETE_REQUEST';
export function jobSearchDeleteRequest(deleteIds) {
    return {
        type: JOB_SEARCH_DELETE_REQUEST,
        payload: {
            deleteIds,
        }
    };
}

export const JOB_SEARCH_DELETE_SUCCESS = 'JOB_SEARCH_DELETE_SUCCESS';
export function jobSearchDeleteSuccess(payload) {
    return {
        type: JOB_SEARCH_DELETE_SUCCESS,
        payload,
    };
}

export const JOB_SEARCH_DELETE_FAILURE = 'JOB_SEARCH_DELETE_FAILURE';
export function jobSearchDeleteFailure(error) {
    return {
        type: JOB_SEARCH_DELETE_FAILURE,
        payload: JSON.stringify(error),
    };
}
